import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import { HolidayStructureColumns, SalesTeamCountColumnsPopupForHolidayStructure } from "../../tableColumns/table-columns";
import { holidayStructureJson } from "../../DynamicFormsJson/Transaction/holidayStructure";
import { getHolidayStructureGetAll } from "../../Slice/year.slice";

class HolidayStructureTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { yearList, getHolidayStructureGetAll } = this.props;
        return (
            <>
                <DynamicMainScreen
                    formPath={holidayStructureJson.formPath}
                    screenTitle={holidayStructureJson.screenTitle}
                    fieldMeta={holidayStructureJson.fieldMeta}
                    showPdfDownload={false}
                    showExcelDownload={true}
                    changeExcelURL={holidayStructureJson.excelUrl}
                    showExtension={false}
                    filterDataExcel={true}
                    pdfFileName={holidayStructureJson.pdfFileName}
                    excelFileName={holidayStructureJson.excelFileName}
                    showAddButton={holidayStructureJson.showAddButton}
                    tableColumnsToFilter={holidayStructureJson.tableColumnsToFilter}
                    tableColumns={HolidayStructureColumns}
                    tableData={yearList?.holidayStructure}
                    getTableData={getHolidayStructureGetAll}
                    apiBaseURL={holidayStructureJson.apiBaseURL}
                    baseIdColumn={holidayStructureJson.baseIdColumn}
                    isNote={true}
                    isNoteValue={"Add Hoiday Structure"}
                    showDeleteIcon={true}
                    showViewButtonInTable={false}
                    formPathView={holidayStructureJson.formPathView}
                    isActiveURL={holidayStructureJson.isActiveURL}
                    showPopUpDataList={[
                        {
                            dataKey: "salesTeamCount",
                            columns: SalesTeamCountColumnsPopupForHolidayStructure,
                            title: "Sales Team Count",
                            isActionColActive: true,
                            header: {
                                dataKey: "name",
                                label: "Structure Name",
                            },
                        },
                    ]}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    yearList: state.year,
});
const mapDispatchToProps = {
    getHolidayStructureGetAll,
};
export default connect(mapStateToProps, mapDispatchToProps)(HolidayStructureTable);
